var GlobalController = function ($scope, $q, checkConnection, ERR, errorScreenService, errorRouterService) {
    var vm = this,
        onlineListenerHandler,
        offlineListenerHandler;

    //skip long requests exceptions in error routing service,
    //to prevent error screen showing after state change.
    var httpErrorsListeners = [];
    httpErrorsListeners.push(errorRouterService.subscribe(function (err) {
        return $q.when(true);
    }, { resourceName: 'resolveRecalls', status: '*' }));

    function init() {
        //store default options for global error
        var options = {
            global: true,
            template: 'template/errorscreens/connection-lost',
            errorType: ERR.CONNECTION_LOST
        };

        vm.errorScreenOptions = {
            global: true,
            errorType: ERR.CONNECTION_LOST
        };

        onlineListenerHandler = checkConnection.subscribeOnline(function () {
            //vm.visible = true;
            errorScreenService.error(false, ERR.CONNECTION_LOST, options);
        });
        offlineListenerHandler = checkConnection.subscribeOffline(function () {
            //vm.visible = false;
            errorScreenService.error(true, ERR.CONNECTION_LOST, options);
        });
        checkConnection.startChecker();
    };

    $scope.$on('$destroy', function () {
        checkConnection.unsubscribe(onlineListenerHandler);
        checkConnection.unsubscribe(offlineListenerHandler);
        checkConnection.stopChecker();

        httpErrorsListeners.forEach(function (id) {
            errorRouterService.unsubscribe(id);
        });
    });

    init();

};
GlobalController.$inject = ['$scope', '$q', 'CheckConnection', 'errors', 'errorScreenService', 'errorRouterService'];

module.exports = GlobalController;